// frontend/src/App.js

import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useNavigate } from 'react-router-dom';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Survey from './pages/Survey';
import Settings from './pages/Settings';
import api, { surveyApi } from './services/api';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [userEmail, setUserEmail] = useState('');

  const checkAuth = async () => {
    const token = localStorage.getItem('token');
    console.log('Checking authentication, token:', token ? 'exists' : 'not found');
    if (token) {
      try {
        const response = await api.get('/auth/verify');
        console.log('Token verification response:', response.data);
        if (response.data.msg === "Token is valid") {
          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
        }
      } catch (error) {
        console.error('Token verification error:', error.response || error);
        localStorage.removeItem('token');
        setIsAuthenticated(false);
      }
    } else {
      setIsAuthenticated(false);
    }
    setLoading(false);
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      setIsAuthenticated(false);
      setLoading(false);
      return;
    }
    checkAuth();
  }, []);

  const handleLoginSuccess = (email) => {
    setIsAuthenticated(true);
    setUserEmail(email);
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <Router>
      <Routes>
        <Route path="/login" element={!isAuthenticated ? <Login onLoginSuccess={handleLoginSuccess} /> : <Navigate to="/dashboard/projects" replace />} />
        <Route path="/register" element={!isAuthenticated ? <Register /> : <Navigate to="/dashboard/projects" replace />} />
        <Route path="/survey/:projectId" element={<Survey />} />
        <Route path="/survey/:projectId/:customerId" element={<Survey />} />
        {isAuthenticated ? (
          <>
            <Route path="/dashboard/*" element={<Dashboard userEmail={userEmail} onLogout={() => {
              setIsAuthenticated(false);
              setUserEmail('');
            }} />} />
            <Route path="/" element={<Navigate to="/dashboard/projects" replace />} />
          </>
        ) : (
          <>
            <Route path="*" element={<Navigate to="/login" replace />} />
          </>
        )}
      </Routes>
    </Router>
  );
}

export default App;